import { DataIdSchema } from "@/schemas";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { getContactTeamLoader } from "../../contacts/-functions/loaders/teams";

export const Route = createFileRoute("/dashboard/teams/$id")({
	params: {
		parse: (params) => ({
			id: DataIdSchema.parse(Number(params.id)),
		}),
		stringify: ({ id }) => ({ id: id.toString() }),
	},
	loader: ({ context, params }) => getContactTeamLoader(context, params.id),
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
